import * as z from 'zod';

const operatingIntervalSchema = z.object({
  openTime: z.string(),
  durationInMinutes: z.number(),
});

const standardHoursSchema = z.object({
  operationType: z.string(),
  operatingInterval: operatingIntervalSchema.optional(),
  blackoutHours: operatingIntervalSchema.optional(),
});

const holidaySchema = z.object({
  holidayDate: z.string(),
  name: z.string(),
  holidayHours: standardHoursSchema,
});

const hoursOfOperationSchema = z.object({
  monday: standardHoursSchema,
  tuesday: standardHoursSchema,
  wednesday: standardHoursSchema,
  thursday: standardHoursSchema,
  friday: standardHoursSchema,
  saturday: standardHoursSchema,
  holidays: z.array(holidaySchema).optional(),
});

export const locationResultSchema = z.object({
  locationNumber: z.string(),
  name: z.string(),
  marketableName: z.string().optional(),
  operator: z.object({
    name: z.string(),
    guid: z.string().optional(),
    personId: z.string().optional(),
  }),
  locationContact: z.object({
    streetAddress: z.any().optional(),
    daytimePhone: z.any().optional(),
    emailAddress: z.string(),
  }),
  status: z.string(),
  openDate: z.string().optional(),
  projectedOpenDate: z.string().optional(),
  marketableURL: z.string().optional(),
  gps: z.object({
    latitude: z.number(),
    longitude: z.number(),
  }),
  conceptCode: z.string(),
  locationOperatingAs: z.string().optional(),
  dflsUsed: z.string().optional(),
  marketName: z.string().optional(),
  marketLevelMarketCode: z.string().optional(),
  operatorTeamName: z.string().optional(),
  operatorTeamCode: z.string().optional(),
  serviceTeamName: z.string().optional(),
  serviceTeamCode: z.string().optional(),
  mobileOrderingSettings: z.object({
    status: z.string(),
    maxTotalAmount: z.number(),
    menuWarnings: z.array(z.string()),
    fulfillmentMethods: z.object({
      cateringPickup: z.any().optional(),
      cateringDelivery: z.any().optional(),
    }),
    menuCustomization: z.boolean(),
    isNotificationDelayed: z.boolean(),
  }),
  restaurantHours: z.object({
    hoursOfOperation: hoursOfOperationSchema,
  }),
  timeZone: z.string(),
  digitalFeatures: z.object({
    servesBreakfast: z.boolean(),
    servesLimitedMenu: z.boolean(),
    offersMobileOrdering: z.boolean(),
    offersMobilePayment: z.boolean(),
    offersCustomerWifi: z.boolean(),
  }),
  physicalFeatures: z.object({
    playground: z.string(),
    hasDriveThru: z.boolean(),
    hasDiningRoom: z.boolean(),
  }),
  taxType: z.string(),
  supportedLanguages: z.array(z.string()),
  restaurantImageURL: z.string(),
  activeFlags: z.array(z.string()),
  nearbyLocations: z.array(z.string()),
  locationCode: z.string(),
  locationFormat: z.string().optional(),
  locationSubtypeCode: z.string(),
});

export type LocationResult = z.infer<typeof locationResultSchema>;

export const eulaMessageTextSchema = z.object({
  content: z.string(),
});

export type EulaMessage = z.infer<typeof eulaMessageTextSchema>;
